import IframeActivity from "./IframeActivity";

export default function ProblemSolving() {
    return (
        <IframeActivity
            src="/activities/problem-solving/index.html"
            title="Problem Solving"
        />
    );
}